import { render } from "./GruposComparacaoField.vue?vue&type=template&id=6d4e726a&scoped=true"
import script from "./GruposComparacaoField.vue?vue&type=script&lang=js"
export * from "./GruposComparacaoField.vue?vue&type=script&lang=js"

import "./GruposComparacaoField.vue?vue&type=style&index=0&id=6d4e726a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4e726a"]])

export default __exports__